export class AssessmentTypeIri {
  public static readonly INTELLIGENCES_ASSESSMENT_TYPE_IRI = '/api/assessment_types/1';
  public static readonly LEARNING_AND_PRODUCTIVITY_ASSESSMENT_TYPE_IRI = '/api/assessment_types/2';
  public static readonly LEARNING_AND_PRODUCTIVITY_COLLEGE_ASSESSMENT_TYPE_IRI = '/api/assessment_types/3';
  public static readonly PERSONALITY_ASSESSMENT_TYPE_IRI = '/api/assessment_types/4';
  public static readonly SKILLS_ASSESSMENT_TYPE_IRI = '/api/assessment_types/8';
  public static readonly TRUTALENTS_ASSESSMENT_TYPE_IRI = '/api/assessment_types/9';

  public static readonly AAA_Computation = '/api/assessment_types/10';
  public static readonly AAA_Fluid_Reasoning_1 = '/api/assessment_types/11';
  public static readonly AAA_Fluid_Reasoning_2 = '/api/assessment_types/12';
  public static readonly AAA_Logic = '/api/assessment_types/13';
  public static readonly AAA_Mathematical_Reasoning = '/api/assessment_types/14';
  public static readonly AAA_Memory_1 = '/api/assessment_types/15';
  public static readonly AAA_Memory_2 = '/api/assessment_types/16';
  public static readonly AAA_Processing_Speed_1 = '/api/assessment_types/17';
  public static readonly AAA_Processing_Speed_2 = '/api/assessment_types/18';
  public static readonly AAA_Spatial = '/api/assessment_types/19';
  public static readonly AAA_Vocabulary = '/api/assessment_types/20';
  public static readonly APTITUDES_ASSESSMENT_TYPE_IRI = '/api/assessment_types/21';

  public static readonly APTITUDE_SECTION_ASSESSMENTS = [
    AssessmentTypeIri.AAA_Computation,
    AssessmentTypeIri.AAA_Fluid_Reasoning_1,
    AssessmentTypeIri.AAA_Fluid_Reasoning_2,
    AssessmentTypeIri.AAA_Logic,
    AssessmentTypeIri.AAA_Mathematical_Reasoning,
    AssessmentTypeIri.AAA_Memory_1,
    AssessmentTypeIri.AAA_Memory_2,
    AssessmentTypeIri.AAA_Processing_Speed_1,
    AssessmentTypeIri.AAA_Processing_Speed_2,
    AssessmentTypeIri.AAA_Spatial,
    AssessmentTypeIri.AAA_Vocabulary,
  ];

  public static readonly ASSESSMENTS_TYPES_WITH_CAREERS = [
    AssessmentTypeIri.INTELLIGENCES_ASSESSMENT_TYPE_IRI,
    AssessmentTypeIri.PERSONALITY_ASSESSMENT_TYPE_IRI,
    AssessmentTypeIri.SKILLS_ASSESSMENT_TYPE_IRI,
    AssessmentTypeIri.APTITUDES_ASSESSMENT_TYPE_IRI,
    ...this.APTITUDE_SECTION_ASSESSMENTS,
  ];
}
